const isUserLoggedIn = (preferredName: string): boolean => (!(preferredName === null))

export default isUserLoggedIn
